import { Component } from '@angular/core';

@Component({
  selector: 'icon-minimize',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M6.66666 16H25.3333" stroke="#F8F9FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    @import '../assets/colors.scss';

    svg{
        cursor: pointer;
        path{
          stroke: $text_header_color
        }
    }
  `
})

export class MinimizeIconComponent {}
